import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, startWith } from 'rxjs/operators';
import { DataSharingService } from '../../../../../middleware/common/resuableServices/data-sharing.service';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Inject } from '@angular/core';
@Component({
  selector: 'app-add-nta-dialog',
  templateUrl: './add-nta-dialog.component.html',
  styleUrls: ['./add-nta-dialog.component.scss']
})
export class AddNtaDialogComponent implements OnInit {
  ntaForm: FormGroup;
  icdList: any[] = [];
  dialogTitle: string = 'Add New NTA';
  dialogSaveUpdate='Save'
  filteredOptions!: Observable<any[]>;
  ntaConditionOptions: string[] = [];
  clinicalCategoryOptions: any[] = [];
  statusOptions = [
    { label: 'Definite', value: 1 },
    { label: 'Review', value: 2 }
  ];

  constructor(private fb: FormBuilder,
     private dataSharingService: DataSharingService,
     public dialogRef: MatDialogRef<AddNtaDialogComponent>,
     @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    this.ntaForm = this.fb.group({
      diagnosisName: [''],
      icd10: [null, Validators.required],
      ntaCondition: [null, Validators.required],
      clinicalCategory: [null, Validators.required],
      points: [0],
      risk: ['Low'],
       status: [null, Validators.required],
      isInclude: [true] // checkbox default true
    });
  }

  ngOnInit(): void {

    this.loadICD10Codes();
    this.loadConditionList();
    this.loadCategoryList();
  if (this.data?.ntaItem) {
        this.dialogTitle = 'Update NTA';
       this.dialogSaveUpdate='Update'
    const ntaItem = this.data.ntaItem;
    this.ntaForm.patchValue({
      diagnosisName: ntaItem.diagnosis,
      icd10: { code: ntaItem.icD10, },
      ntaCondition: ntaItem.ntaCondition,
      clinicalCategory: ntaItem.clinicalCategory,
      points: ntaItem.ntaPoint,
      risk: ntaItem.risk,
      status:Number(ntaItem.statusId),
      isInclude: ntaItem.isInclude
    });
  }

  }

  loadICD10Codes() {
    this.dataSharingService.getCodeList().subscribe(data => {
      this.icdList = data.map(item => ({
        ...item,
        codeLower: item.code.toLowerCase(),
        descriptionLower: item.description.toLowerCase()
      }));

      this.filteredOptions = this.ntaForm.get('icd10')!.valueChanges.pipe(
        startWith(''),
        debounceTime(200),
        distinctUntilChanged(),
        map(value => (typeof value === 'string' ? value : value?.code || '')),
        map(codeOrDesc => this._filterCodeList(codeOrDesc))
      );
    });
  }

  private _filterCodeList(value: string): any[] {
    const filterValue = value.toLowerCase();
    return this.icdList
      .filter(option =>
        option.codeLower.includes(filterValue) || option.descriptionLower.includes(filterValue)
      )
      .slice(0, 20);
  }

  displayFn(option: any): string {
    return option ? option.code : '';
  }

  onCodeSelected(event: MatAutocompleteSelectedEvent): void {
    const selected = event.option.value;
    if (selected) {
      this.ntaForm.patchValue({
        icd10: selected
      });
    }
  }

  loadConditionList() {
    this.dataSharingService.getConditionList().subscribe(data => {
      this.ntaConditionOptions = data.map((item: any) => item.Condition);
    });
  }

  loadCategoryList() {
    this.dataSharingService.getPDPMCategory().subscribe(data => {
      // Map JSON list { CategoryId, Name } to dropdown
      this.clinicalCategoryOptions = data.map((item: any) => ({
        id: item.CategoryId,
        name: item.Name
      }));
    });
  }

onSave(): void {
  if (this.ntaForm.valid) {
    const formValue = this.ntaForm.value;

    const ntaObject = {
     ntaid: this.data?.ntaItem?.ntaid || 0,
      diagnosis: formValue.diagnosisName,
      icD10: formValue.icd10?.code || formValue.icd10,
      ntaCondition: formValue.ntaCondition,
      description: null,
      clinicalCategory: formValue.clinicalCategory,
      ntaPoint: formValue.points,
      proposedICD10: null,
      potential: 0,
      risk: formValue.risk,
      isInclude: formValue.isInclude,
      status: formValue.status
    };

    // Close modal and pass data back to parent
    this.dialogRef.close({ action: 'save', data: ntaObject });
  }
}


onCancel(): void {
  this.dialogRef.close(); 
}
}
